const COMPACT = new Intl.NumberFormat("en-US", {
  maximumSignificantDigits: 4,
});

const WHOLE = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });

/**
 * A metric value as the Metrics table shows it at a glance: at most four
 * significant digits, with thousands separators (`0.09820`, `4,336`). An
 * integer is shown whole (`12,345`), never rounded. The full value goes in a
 * tooltip and the details panel, since rounding can hide a difference that
 * matters.
 */
export function formatMetricValue(value: number): string {
  return Number.isInteger(value) ? WHOLE.format(value) : COMPACT.format(value);
}

/** `value` with its unit after it, when the metric has one. */
export function withUnit(value: string, unit: string | null): string {
  return unit ? `${value} ${unit}` : value;
}
